import { create } from 'zustand';
import type { Id } from '~/convex/_generated/dataModel';

interface HomeUploadState {
  selectedTemplate: Id<'templates'> | null;
  setSelectedTemplate: (id: Id<'templates'> | null) => void;
  isUploading: boolean;
  setIsUploading: (value: boolean) => void;
  isCreating: boolean;
  setIsCreating: (value: boolean) => void;
}

export const useHomeUploadStore = create<HomeUploadState>((set) => ({
  selectedTemplate: null,
  setSelectedTemplate: (id) => set({ selectedTemplate: id }),
  isUploading: false,
  setIsUploading: (value) => set({ isUploading: value }),
  isCreating: false,
  setIsCreating: (value) => set({ isCreating: value }),
}));
